import { Controller, useFormContext } from 'react-hook-form';

import { AkselLocale, Combobox } from 'components/form/aksel';

export default function MultiSelect({
	name,
	label,
	defaultValue = null,
	options = [],
	helperText,
	error = false,
	...rest
}) {
	const { control } = useFormContext();

	/* Map combobox strings back to the original option IDs. */
	const listed = options.map(option => ({
		value: String(option.value),
		label: option.label ?? 'Mangler navn',
	}));

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultValue ?? []}
			render={({
				field: { onChange, onBlur, ref, value, disabled },
				fieldState,
			}) => {
				const held = Array.isArray(value) ? value : [];

				return (
					<AkselLocale>
						<div className="mb-4">
							<Combobox
								id={`${name}-multiple-select`}
								label={label}
								isMultiSelect
								options={listed}
								selectedOptions={held.map(
									one =>
										listed.find(
											item => item.value === String(one)
										) ?? {
											value: String(one),
											label: 'Mangler navn',
										}
								)}
								onToggleSelected={(chosen, isSelected) => {
									const option = options.find(
										item => String(item.value) === chosen
									);
									const id = option ? option.value : chosen;

									onChange(
										isSelected
											? [
													...held.filter(
														one => one !== id
													),
													id,
												]
											: held.filter(one => one !== id)
									);
								}}
								{...rest}
								description={helperText}
								error={fieldState.error?.message || error}
								onBlur={onBlur}
								ref={ref}
								disabled={disabled || rest.disabled}
							/>
						</div>
					</AkselLocale>
				);
			}}
		/>
	);
}
